<template>
<b-container >
    <b-row>
        
        <b-col class="selector_fond_carte" style="padding-bottom: 10px !important;">
            <b-button class="btn-select-carte" v-bind:class="[$store.state.map_settings.selected_mode === 0 ? 'is_selected_mode' : '']" @click="setFondCarte(0)">
                <img src="../assets/fond_carte/topo.jpg">

            </b-button>
                        <b-button class="btn-select-carte" v-bind:class="[$store.state.map_settings.selected_mode  === 1 ? 'is_selected_mode' : '']" @click="setFondCarte(1)">
            <img src="../assets/fond_carte/terrain.jpg">

            </b-button>
                        <b-button class="btn-select-carte" v-bind:class="[$store.state.map_settings.selected_mode  === 2 ? 'is_selected_mode' : '']" @click="setFondCarte(2)">
            <img src="../assets/fond_carte/map.jpg">

            </b-button>
            
        </b-col>
    </b-row>
</b-container>
</template>

<script>
export default {
  components: {},
   data () {
     return {


     }
   },
   methods :{
       setFondCarte(f){
           this.$store.commit("setFondCarte",f);
           this.$forceUpdate();
       }
   },

 }
</script>

<style>
.btn-select-carte{
    background-color:transparent !important;
    padding:0 !important;
    overflow:hidden;
}

</style>
